package ai.jessie.web.customers

internal val addressTypes =
    mapOf(
        "PRIMARY" to "Hauptadresse",
        "BILLING" to "Rechnungsadresse",
        "OTHER" to "Weitere Adresse",
    )

internal fun statusLabel(status: String) =
    when (status) {
        "ACTIVE" -> "Aktiv"
        "ARCHIVED" -> "Archiviert"
        else -> "Nicht verfügbar"
    }

private val fieldLabels =
    mapOf(
        "type" to "Kundentyp",
        "displayName" to "Name",
        "email" to "E-Mail",
        "phone" to "Telefon",
        "status" to "Status",
        "line1" to "Adresszeile 1",
        "line2" to "Adresszeile 2",
        "postalCode" to "PLZ",
        "city" to "Ort",
        "countryCode" to "Land",
        "name" to "Name",
        "role" to "Funktion",
    )

// Server field paths such as `addresses[0].line1` become «Adresse 1: Adresszeile 1».
internal fun customerFieldLabel(field: String): String {
    val leaf = fieldLabels[field.substringAfterLast('.')] ?: field
    val number = field.substringAfter('[', "").substringBefore(']').toIntOrNull()?.plus(1)
    return when {
        field.startsWith("addresses[") -> "Adresse $number: $leaf"
        field.startsWith("contacts[") -> "Kontakt $number: $leaf"
        else -> leaf
    }
}

// A6, BR-065: the correction for each field the server or the form identified.
internal fun customerCorrection(field: String) =
    when (field.substringAfterLast('.')) {
        "type" -> "Bitte eine Auswahl treffen."
        "displayName" -> "Pflichtfeld, höchstens 200 Zeichen."
        "email" -> "Bitte eine gültige E-Mail-Adresse eingeben oder das Feld leeren."
        "phone" -> "Höchstens 50 Zeichen."
        "line1" -> "Pflichtfeld, höchstens 200 Zeichen."
        "line2" -> "Höchstens 200 Zeichen."
        "postalCode" -> "Pflichtfeld, höchstens 20 Zeichen."
        "city",
        "name" -> "Pflichtfeld, höchstens 100 Zeichen."
        "countryCode" -> "Bitte einen zweistelligen ISO-Ländercode eingeben, zum Beispiel CH."
        "role" -> "Höchstens 100 Zeichen."
        else -> "Bitte prüfen."
    }
